
import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ApiGateway, PageOptions, ServiceCharacter } from 'cw-backend';
import { CwUtils } from 'cw-utils';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class ServiceCharacterListProvider implements Resolve<any> {
    serviceCharacter: ServiceCharacter[];
    serviceCharacterEdit: ServiceCharacter;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(
        public gw: ApiGateway,
        private location: Location,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        this.currentPage = this.state?.currentPage;
        this.serviceCharacterEdit = this.state?.currentServiceCharacter;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
        }
        else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = 'code';
        }
        return new Promise<void>((resolve, reject) => {
            Promise.all([
                this.getPage(this.pageOptions)
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    get(id: number): Observable<ServiceCharacter> {
        if (!id) {
            return null;
        }
        return this.gw.get('serviceCharacter/:id', { id: id });
    }

    get currentServiceCharacter(): ServiceCharacter {
        return this.serviceCharacterEdit;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('serviceCharacter/').subscribe((res: HttpResponse<any>) => {
                this.serviceCharacter = res.body;
                resolve(res);
            }, reject);
        });

    }

    getPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('serviceCharacter/search', pageOptions).subscribe((res: HttpResponse<any>) => {
                if (!CwUtils.compare(this.serviceCharacter, res.body.content) && res.body.content.length > 0) {
                    this.serviceCharacter = res.body.content;
                    this.onDataChanged.next(this.serviceCharacter);
                }
                else {
                    this.serviceCharacter = res.body.content;
                };
                resolve(res);
            }, reject);
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}

